.activeClient {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 44px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  cursor: pointer;
  font-family: var(--font-family__heading);

  .arrowDropDown {
    font-size: 36px;
    padding-right: 15px;
  }

  &.singleClient {
    cursor: default;

    .arrowDropDown {
      display: none;
    }
  }

  .imageHolder {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 25px;
    margin-left: 13px;
    margin-right: 8px;

    img {
      max-height: 85%;
      max-width: 85%;
    }
  }

  .content {
    flex: 1;
    font-size: 18px;
  }

  &.collapsed {
    .content {
      display: none;
    }

    .arrowDropDown {
      display: none;
    }
  }
}
